
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-600 via-teal-500 to-cyan-500 overflow-hidden pt-28">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full mb-6 border border-white/30">
            <i className="ri-rocket-line text-sm"></i>
            <span className="text-sm font-semibold">Bora abandonar as planilhas!</span>
          </div>

          {/* Main title */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-6 leading-tight">
            Cálculos de Ponto e Rescisão
            <br />
            <span className="text-yellow-300">em Instantes</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            O sistema mais completo para cálculos de pontos. Faça também cálculos e conferência de rescisões e muito mais. 
            Relatórios em PDF com sua logo personalizada.
          </p>

          {/* Video embed */}
          <div className="max-w-4xl mx-auto mb-8">
            <div className="relative bg-white/10 backdrop-blur-sm rounded-2xl p-4 border border-white/20">
              <div className="aspect-video bg-gradient-to-br from-gray-900 to-gray-800 rounded-xl overflow-hidden">
                <iframe 
                  src="https://www.youtube.com/embed/OXYkNE7-8d0?autoplay=1&mute=1&loop=1&playlist=OXYkNE7-8d0&controls=1&modestbranding=1&rel=0"
                  title="CalculaDP - Como funciona"
                  className="w-full h-full rounded-xl"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <p className="text-white/80 text-center mt-3 text-sm">
                ▶ Veja como funciona em 3 minutos
              </p>
            </div>
          </div>

          {/* CTA Button */}
          <div className="space-y-4">
            <button 
              className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 px-12 py-4 rounded-xl text-xl font-bold shadow-2xl hover:shadow-3xl transition-all transform hover:scale-105 whitespace-nowrap"
              onClick={() => window.open('https://calculadp.tiagonogueira.com.br/ponto', '_blank')}
            >
              <i className="ri-calculator-line mr-2"></i>
              ACESSAR SISTEMA AGORA
            </button>
            <p className="text-white/80 text-sm">
              ✅ Teste grátis • ✅ Garantia Incondicional de 7 dias
            </p>
          </div>

          {/* Social proof */}
          <div className="mt-12 flex items-center justify-center gap-8 text-white/80">
            <div className="text-center">
              <div className="text-2xl font-bold text-white">+500</div>
              <div className="text-sm">Usuários ativos</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white">4.9⭐</div>
              <div className="text-sm">Avaliação média</div>
            </div>
          </div>
        </div>
      </div>

      {/* Animated background elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-white/5 rounded-full animate-bounce"></div>
      <div className="absolute bottom-20 right-10 w-16 h-16 bg-white/5 rounded-full animate-bounce" style={{ animationDelay: '0.5s' }}></div>
      <div className="absolute top-1/2 left-20 w-12 h-12 bg-white/5 rounded-full animate-bounce" style={{ animationDelay: '1s' }}></div>
    </section>
  );
}
